/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { ApiResponse, ApiResponseError, ErrorData } from '../interfaces'

export type AddressResponse = {
  id: number
  zipCode: string
  type: string
  street: string
  district: string
  city: string
  state: string
  locale: boolean
  dateCreated: string
  lastUpdated: string
}

const fetchAddressDataFromMiddleware = async (
  zipCode: string,
  accessToken: string,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<AddressResponse | ErrorData>> => {
  const url = `${middleware?.url}${zipCode}`

  try {
    const { data, status } = (await axios({
      ...middleware,
      url,
      headers: { ...middleware?.headers, Authorization: accessToken },
    })) as AxiosResponse<AddressResponse>

    return {
      data,
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ApiResponseError>
    const { data, status } = response!

    return {
      data: data.error,
      status,
      success: false,
    }
  }
}

export default fetchAddressDataFromMiddleware
